import { toastr } from "react-redux-toastr";
import Api from "../../utils/config/api";
import {
  RESET_SHORTLINK_STATE,
  SET_SHORTLINK_DATA,
  SET_TEMPLATE_SHORTLINK_DATA,
  SET_UPDATED_CUST_DATA,
} from "../types";

export const setShortlinkData = (payload) => (dispatch) => {
  dispatch({
    type: SET_SHORTLINK_DATA,
    payload,
  });
};

export const setSortlinkDetails = (code, query) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/utility/shortlink/${code}${query || ""}`)
      .then((res) => {
        dispatch(setShortlinkData(res?.data?.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getShortlinkRewards = (storeId, customerId) => {
  return new Promise((resolve, reject) => {
    Api.get(`v1/utility/customer/rewards/${storeId}/${customerId}?format=false`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error("Validation Error", errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateCustDetails = (code, values) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/utility/customer/update/${code}`, values)
      .then((res) => {
        dispatch({
          type: SET_UPDATED_CUST_DATA,
          payload: res?.data?.payload,
        });
        toastr.success("Profile Updated Successfully");
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error("Validation Error", errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const setTemplateSortlinkDetails = (templateCode) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/campaigns/shortlink/${templateCode}`)
      .then((res) => {
        dispatch({
          type: SET_TEMPLATE_SHORTLINK_DATA,
          payload: res?.data?.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateFeedBackDets = (storeId, customerId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/feedback/${storeId}/customer-feedback/${customerId}`, data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const resetShortlinkState = () => (dispatch) => {
  dispatch({
    type: RESET_SHORTLINK_STATE,
  });
};

// opt-out message for customers
// for subcribe send empty stop_messages array in data
// for unsubcribe send type of messages in stop_messages array in data
export const toggleWaMessageOptOut = (entityId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/channels/unsubscribe/${entityId}`, data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getWaCampaignUnsubscribeLink = (entityId, campaignId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/campaigns/${campaignId}/unsubscribe-link/${entityId}`)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};
